/**
 * Error bodies from endpoints that have not been migrated to a structured error contract.
 *
 * Most services return `{ message }`, but some — the reservations service among them — return the
 * exception message as a bare string, so both forms have to be handled wherever an error is shown to a
 * user. Short-term measure: delete this once those endpoints return a consistent body.
 */
export type LegacyErrorBody = string | { message?: string } | undefined

export interface LegacyErrorResponse {
  response?: {
    data?: LegacyErrorBody
  }
}

/**
 * Pulls a displayable reason out of a failed request. Returns undefined when the response carries
 * neither form, leaving the caller to supply its own wording.
 */
export const legacyErrorDetail = (e: unknown): string | undefined => {
  const data = (e as LegacyErrorResponse)?.response?.data
  return typeof data === 'string' ? data : data?.message
}
